var _path, _path2, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSulphur(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 80,
    height: 80,
    viewBox: "0 0 80 80",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.33359 72H45.6003L53.7336 47.4667L50.6669 30.6667L55.6003 8H30.6669C30.1336 8 29.7336 8.26667 29.4669 8.66667L16.1336 35.3333C16.0003 35.6 16.0003 36 16.0003 36.1333L18.6669 52.9333L8.13359 70C7.86693 70.4 7.86693 70.9333 8.13359 71.3333C8.40026 71.7333 8.80026 72 9.33359 72Z",
    fill: "url(#paint0_linear_301_2901)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M69.2004 31.4667L59.3337 8.8C59.2004 8.4 58.8004 8 58.2671 8L53.3337 30.6667L56.4004 47.6L48.4004 72H70.6671C71.0671 72 71.3337 71.8667 71.6004 71.6C71.8671 71.3333 72.0004 70.9333 72.0004 70.5333L69.3337 31.8667C69.3337 31.7333 69.3337 31.6 69.2004 31.4667Z",
    fill: "url(#paint1_linear_301_2901)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_301_2901",
    x1: 56.218,
    y1: 8.97264,
    x2: -5.39509,
    y2: 53.597,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F45634"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.504,
    stopColor: "#9D2161"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1E1C49"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_301_2901",
    x1: 72.3062,
    y1: 8.97264,
    x2: 31.0983,
    y2: 23.7494,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F45634"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.504,
    stopColor: "#9D2161"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1E1C49"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSulphur);
export default __webpack_public_path__ + "static/media/sulphur.dc43dda6a879395e8aa8e6377517cb3a.svg";
export { ForwardRef as ReactComponent };